import { Injectable } from '@angular/core';
import { cloneDeep } from 'lodash-es';
import { FuseNavigationItem } from '@fuse/components/navigation';
import { FuseMockApiService } from '@fuse/lib/mock-api';
import { compactNavigation, defaultNavigation } from 'app/core/mock-api/common/navigation/data';

@Injectable({ providedIn: 'root' })
export class NavigationMockApi {
  private readonly _defaultNavigation: FuseNavigationItem[] = defaultNavigation;
  private readonly _compactNavigation: FuseNavigationItem[] = compactNavigation;

  /**
   * Constructor
   */
  constructor(private _fuseMockApiService: FuseMockApiService) {
    // Register Mock API handlers
    this.registerHandlers();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Register Mock API handlers
   */
  registerHandlers(): void {
    // -----------------------------------------------------------------------------------------------------
    // @ Navigation - GET
    // -----------------------------------------------------------------------------------------------------
    this._fuseMockApiService
      .onGet('api/common/navigation')
      .reply(() => {

        // Fill compact navigation children using the default navigation
        this._compactNavigation.forEach((compactNavItem) => {
          this._defaultNavigation.forEach((defaultNavItem) => {
            if (defaultNavItem.id === compactNavItem.id) {
              compactNavItem.children = cloneDeep(defaultNavItem.children);
            }
          });
        });

        return [
          200, {
            default: cloneDeep(this._defaultNavigation),
            compact: cloneDeep(this._compactNavigation)
          }
        ];
      });
  }
}
